<template>
  <div class="header-box flex-row-justify-center">
    <div class="header-left" @click="toPath('/')">
      <img src="../../assets/images/logol.png" style="width:430px;height:50px">
    </div>
    <div class="header-right">
      <div class="flex-row-start-center">
        <div class="control-item" @click="setHome($event)">设为首页</div>
        <div class="control-split"></div>
        <div class="control-item" @click="shoucang">加入收藏</div>
        <div class="control-item has-bg contactUs" @click="toPath('/index/lists/008004')">联系我们</div>
      </div>
      <div class="search-box">
        <el-input
          placeholder="请输入关键字"
          v-model="searchText"
          :maxlength="50"
          size="mini"
          class="input-with-select"
          @keyup.enter.native="handleSearch">
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      searchText: ''
    }
  },
  methods: {
    toPath(path) {
      if(this.$route.path !== path) {
        this.$router.push({ path: path })
      }
    },
    // 设置为主页
    setHome(obj){
      const vrl = window.location;
      try{
        obj.target.style.behavior = 'url(#default#homepage)';
        obj.target.setHomePage(vrl);
      } catch(e){
        if(window.netscape) {
          try {
            window.netscape.security.PrivilegeManager.enablePrivilege("UniversalXPConnect");
          } catch (e) {
            alert("此操作被浏览器拒绝！\n请在浏览器地址栏输入“about:config”并回车\n然后将 [signed.applets.codebase_principal_support]的值设置为'true',双击即可。");
          }
          const prefs = window.Components.classes['@mozilla.org/preferences-service;1'].getService(window.Components.interfaces.nsIPrefBranch);
          prefs.setCharPref('browser.startup.homepage',vrl);
        } else{
          alert("您的浏览器不支持，请按照下面步骤操作：1.打开浏览器设置。2.点击设置网页。3.输入："+vrl+"点击确定。");
        }
      }
    },
    // 加入收藏 兼容360和IE6
    shoucang() {
      const sURL = window.location;
      const sTitle = document.title;
      try {
        window.external.addFavorite(sURL, sTitle);
      } catch (e) {
        try {
          window.sidebar.addPanel(sTitle, sURL, "");
        } catch (e) {
          alert("加入收藏失败，请使用Ctrl+D进行添加");
        }
      }
    },
    handleSearch() {
      if(!this.searchText) {
        return
      }
      this.$router.push({
        path: '/index/search',
        query: {
          //强制刷新
          key: new Date().getTime(),
          keyword: this.searchText
        }
      })
      this.searchText = ""
    }
  }
}
</script>

<style lang="scss" scoped>
.header-box {
  width: 1005px;
  height: 80px;
  margin: 0 auto;
  .header-left {
    cursor: pointer;
  }
  .header-right {
    .control-item {
      width: 76px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 10px;
      cursor: pointer;
      &.has-bg {
        background-color: #9fadba;
        color: #ffffff;
      }
      &:hover {
        background-color: #9fadba;
        color: #ffffff;
      }
    }
    .control-split {
      width: 1px;
      height: 14px;
      background-color: #9fadba;
    }
    .search-box {
      margin-top: 5px;
    }
  }
}
</style>